import { createApp } from 'vue';
import { ModalSystemApplication } from './application';

export class ModalManagementSystem { 
    async init({ store }) {
        const app = createApp(ModalSystemApplication);
        app.use(store);
        app.mount('.modal-management-system');
    }
}